<mat-card class="container mt-4 mb-4">
    <mat-card-content>
        <div class="card boxshadow-card box-cart">
            <div class="col-md-12">
                <p *ngIf="!overTimeConfirmation">
                    Mã xác nhận đã được gửi đến số điện thoại <span
                        class="font-weight-bold">{{isPhoneSended}}</span><br>
                    Quý khách vui lòng kiểm tra tin nhắn và điền mã xác nhận vào ô bên dưới trong vòng <span #total1Ref
                        class="font-weight-bold" [counter]="counter" [interval]="interval"
                        (value)="getValueCounterInterval($event)" [innerHTML]="valueCounter">
                    </span>
                    giây<br>
                    Nếu quý khách không nhận được tin nhắn, vui lòng nhấn vào Gửi lại mã
                </p>
                <p *ngIf="overTimeConfirmation">Hết hạn nhập mã xác thực. Quý khách vui lòng nhấn Gửi lại mã. Nếu vẫn
                    chưa nhận được mã xác
                    thực, quý
                    khách vui lòng liên hệ tổng đài CSKH để được hỗ trợ</p>
                <form (ngSubmit)="f.form.valid && confirmOtp();" #f="ngForm" novalidate>
                    <div class="row">
                        <div class="col-md-12">
                            <input #focusFirstElement type="text" class="form-control" id="verification"
                                [ngClass]="{ 'is-invalid': verification.touched && verification.invalid }"
                                placeholder="Nhập mã xác thực" name="verification" [(ngModel)]="valueOTP"
                                (ngModelChange)="onChangeVerification()" #verification="ngModel" required minlength="4"
                                maxlength="20">
                            <button mat-button *ngIf="valueOTP" type="button" matSuffix mat-icon-button aria-label="Clear"
                                (click)="valueOTP=''">
                                <mat-icon>close</mat-icon>
                            </button>
                            <mat-error class="pt-1" *ngIf="f.submitted && verification.invalid">
                                <span class="text-error" *ngIf="verification?.errors?.required">
                                    Vui lòng nhập mã xác nhận.
                                </span>
                                <span class="text-error" *ngIf="verification?.errors?.minlength">
                                    Mã xác nhận tối thiểu là 4 ký tự.
                                </span>
                                <span class="text-error" *ngIf="verification?.errors?.maxlength">
                                    Mã xác nhận tối đa là 20 ký tự.
                                </span>
                            </mat-error>
                        </div>
                        <div class="col-md-12 text-center mt-3">
                            <button class="btn-order-border mr-4" [ngClass]="{'disabled': !isButtonResendCode}"
                                mat-stroked-button color="primary" type="button" (click)="resendConfirmationCode()">Gửi
                                lại
                                mã</button>
                            <button class="btn-order-border" [ngClass]="{'disabled': !isButtonConfirmCode}"
                                mat-raised-button color="primary" type="submit"
                                [class.disabled]="f.submitted && f.form.invalid">Xác
                                nhận</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

    </mat-card-content>
</mat-card>
<ng4-loading-spinner [threshold]="1000" [timeout]="5800" [zIndex]="9999"></ng4-loading-spinner>
